import axios from 'axios';

const instance = axios.create({
  baseURL: process.env.NODE_ENV === 'development' ? 'http://localhost:3000/api' : 'https://king-boo.herokuapp.com/api',
});

export async function requestLoginEmail(email) {
  return await instance({
    method: 'POST',
    url: '/request-login-email',
    data: {
      email,
    },
  });
}

export async function fetchAdminBookings({ venue }) {
  let bookings = await instance({
    method: 'GET',
    url: '/admin-bookings',
    params: {
      venue,
    },
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('jwt'),
    },
  });

  return bookings.data;
}

export async function fetchBookings({ venue }) {
  let bookings = await instance({
    method: 'GET',
    url: '/bookings',
    params: {
      venue,
    },
  });

  return bookings.data;
}

export async function requestBooking({ data }) {
  let booking = await instance({
    method: 'POST',
    url: '/bookings',
    data,
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('jwt'),
    },
  });


  return booking.data;
}


export async function updateBooking(id, updates) {
  let booking = await instance({
    method: 'PATCH',
    url: '/bookings',
    data: {
      id,
      updates,
    },
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('jwt'),
    },
  });

  return booking;
}

export async function deleteBooking(id) {
  let booking = await instance({
    method: 'DELETE',
    url: '/bookings',
    data: {
      id,
    },
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('jwt'),
    },
  });

  return booking;
}
